import { Dispatch, SetStateAction } from 'react';
import cn from 'classnames';
import { Button } from '../../../Button/Button';

import styles from './YearSelector.module.scss';

interface MonthSelectorProps {
  setYear: Dispatch<SetStateAction<string>>;
  year: string;
  onPrev?: () => void;
  onNext?: () => void;
  onYear?: () => void;
  minMaxYear?: [number, number];
}

export const YearSelector = ({
  setYear,
  year,
  onPrev,
  onNext,
  onYear,
  minMaxYear,
}: MonthSelectorProps) => {
  return (
    <div className={styles.root}>
      <Button
        className={styles.button}
        iconPlace="only-icon"
        icon="left-arrow"
        onClick={onPrev}
        isDisabled={Number(year) - 1 < minMaxYear[0]}
      />
      <Button className={cn(styles.button, styles.month)} onClick={onYear}>
        {year}
      </Button>
      <Button
        className={styles.button}
        iconPlace="only-icon"
        icon="right-arrow"
        onClick={onNext}
        isDisabled={Number(year) + 1 > minMaxYear[1]}
      />
    </div>
  );
};
